import React, { FC } from "react";
import { Spinner } from "@pepdirect/v3/ui/Spinner";
import { StyledWrapper } from "./index.styled";

export const LoadingPage: FC = () => (
  <StyledWrapper>
    <Spinner dotSize="25px" />
  </StyledWrapper>
);
